import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import Disciplines from "./pages/Disciplines";
import DisciplineDetail from "./pages/DisciplineDetail";
import ForStudents from "./pages/ForStudents";
import ForColleges from "./pages/ForColleges";
import ForFaculty from "./pages/ForFaculty";
import Contact from "./pages/Contact";
import Test from "./pages/Test";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/test" element={<Test />} />
        <Route path="/disciplines" element={<Disciplines />} />
        <Route path="/disciplines/:disciplineId" element={<DisciplineDetail />} />
        <Route path="/for-students" element={<ForStudents />} />
        <Route path="/for-colleges" element={<ForColleges />} />
        <Route path="/for-faculty" element={<ForFaculty />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
